export enum TableStationColumns {
  NAME = "name",
  REGION = "region",
}
